var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('c-tabs-navigation',{attrs:{"links":[{
      name: 'Dashboard',
      to: { name: 'dashboard' }
    }, {
      name: 'Konto',
      to: { name: 'dashboard-account' }
    }, {
      name: 'Persönliche Daten',
      to: { name: 'dashboard-personal-data' },
      show: _vm.$is(['applicant'])
    }, {
      name: 'Bankverbindung',
      to: { name: 'dashboard-bank-account' },
      show: _vm.$is(['applicant'])
    }],"aria-label":"Dashboard-Navigation"}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }